import { Button, Card, Stack } from "@mui/material";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs/custom-breadcrumbs";
import PageComponent from "../../../components/page";
import Iconify from "../../../components/iconify";
import useDepartmentList from "./useList";
import DepartmentsFilterComponent from "../components/filters";
import SortByComponent from "../../../components/sort-by-component";
import { columnsTable, departmentOrderOptions } from "../../../constants/department";
import TableComponent from "../../../components/table";
import { IDepartment } from "../../../types/department";
import DepartmentTableRowComponent from "../components/table-row";
import CreateDepartmentDialogComponent from "../components/dialog-create";
import useDepartmentUpdate from "./useUpdate";
import UpdateDepartmentDialogComponent from "../components/dialog-update";

const DepartmentsListPage = () => {

    const { canReset, filters, handleFilters, openFilters, resetFilters, table, departmentsList, getDepartments, loading, loadingFilters, branches, openCreateDialog, methods, isSubmitting, onSubmit, activeDepartment, deleteDepartment, users } = useDepartmentList();
    const { loadingUpdate, onSubmitUpdate, openUpdateDialog, methodsUpdate, setValuesUpdate } = useDepartmentUpdate(getDepartments, loading);

    return (
        <PageComponent>
            <>
                <CustomBreadcrumbs
                    heading="Departamentos"
                    links={[
                        {
                            name: 'Departamentos'
                        },
                        {
                            name: 'Lista'
                        }
                    ]}
                    action={
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon={'mingcute:add-line'} />}
                            onClick={openCreateDialog.onTrue}
                        >
                            Novo Departamento
                        </Button>
                    }
                    sx={{ mb: { xs: 3, md: 5 } }}
                />
                <Stack
                    spacing={3}
                    justifyContent={{ xs: 'space-between', md: 'flex-end' }}
                    alignItems={'center'}
                    direction={'row'}
                    sx={{ mb: { xs: 3, md: 5 } }}
                >
                    <DepartmentsFilterComponent
                        canReset={canReset}
                        filters={filters}
                        getResults={getDepartments}
                        handleFilters={handleFilters}
                        onClose={openFilters.onFalse}
                        onOpen={openFilters.onTrue}
                        open={openFilters.value}
                        resetFilters={resetFilters}
                        branches={branches}
                        loading={loadingFilters.value}
                    />
                    <SortByComponent
                        direction={table.direction}
                        onSort={table.onSort}
                        sortBy={table.sortBy}
                        sortOptions={departmentOrderOptions}
                    />
                </Stack>

                <Card>
                    <TableComponent
                        headLabel={columnsTable}
                        loading={loading.value}
                        table={table}
                        totalCount={departmentsList?.totalCount ?? 0}                        
                    >
                        <>
                            {
                                departmentsList?.data?.map((department: IDepartment) => {
                                    return (
                                        <DepartmentTableRowComponent
                                            key={department.id}
                                            row={department}
                                            onDeleteRow={() => department.deletedAt ? activeDepartment(department.id) : deleteDepartment(department.id)}
                                            onEditRow={() => setValuesUpdate(department)} 
                                        />
                                    )
                                })
                            }
                        </>
                    </TableComponent>
                </Card>

                <CreateDepartmentDialogComponent
                    open={openCreateDialog.value}
                    onClose={openCreateDialog.onFalse}
                    branches={branches}
                    isSubmitting={isSubmitting}
                    methods={methods}
                    onSubmit={onSubmit}
                    users={users}
                />

                <UpdateDepartmentDialogComponent
                    open={openUpdateDialog.value}
                    onClose={openUpdateDialog.onFalse}
                    branches={branches}
                    isSubmitting={loadingUpdate.value}
                    methods={methodsUpdate}
                    onSubmit={onSubmitUpdate}
                    users={users}
                />
            </>
        </PageComponent>
    );

}

export default DepartmentsListPage;